import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FlexiComplianceRouteData } from './flexi-compliance.service';

@Component({
  selector: 'flexi-compliance-container',
  templateUrl: './compliance-container.component.html',
  styleUrls: ['./flexi-compliance.scss'],
  standalone: false
})
export class ComplianceContainerComponent implements OnInit, OnDestroy {
  routeData!: FlexiComplianceRouteData;

  private dataSub?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Subscribed rather than read off the snapshot: the grid route and the
    // per-review route both render this container, so moving between them can
    // reuse the component instance and a snapshot read would keep showing the
    // view we arrived from.
    this.dataSub = this.route.data.subscribe(data => {
      this.routeData = data['compliance'] as FlexiComplianceRouteData;
    });
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
  }
}
